import { API_BETA, jsonHeadersWithToken, authHeaders, parseJsonSafe, getErrorMessage } from '@/lib/constants'

const BASE_URL = API_BETA
const getUserUrl = (userId) => {
  if (!userId) throw new Error('User ID is required')
  return `${BASE_URL}user/${userId}/`
}

const handleResponse = async (response, errorMessage) => {
  if (!response.ok) {
    const errorData = await parseJsonSafe(response)
    throw new Error(getErrorMessage(errorData, errorMessage))
  }
  const result = await parseJsonSafe(response)
  return result.data || result
}

export const getUserProfile = async (userId) => {
  const response = await fetch(getUserUrl(userId), {
    method: 'GET',
    headers: jsonHeadersWithToken(),
  })
  return handleResponse(response, 'Failed to fetch user profile')
}

export const updateUserProfile = async (userId, data) => {
  const response = await fetch(getUserUrl(userId), {
    method: 'PUT',
    headers: jsonHeadersWithToken(),
    body: JSON.stringify(data),
  })
  return handleResponse(response, 'Failed to update user profile')
}

export const changeUserPassword = async (userId, payload) => {
  return updateUserProfile(userId, {
    ...payload,
    passwordChanged: true,
  })
}

export const deleteUserAccount = async (userId) => {
  if (!userId) throw new Error('User ID is required')

  const response = await fetch(getUserUrl(userId), {
    method: 'DELETE',
    headers: jsonHeadersWithToken(),
  })

  return handleResponse(response, 'Failed to delete account')
}

const extractAvatarUrl = (payload) => {
  if (typeof payload === 'string') return payload
  if (payload?.url) return payload.url
  if (payload?.secure_url) return payload.secure_url
  const assets = payload?.assets
  if (Array.isArray(assets) && assets[0]) return assets[0]?.secure_url || assets[0]?.url || ''
  if (assets?.secure_url) return assets.secure_url
  if (assets?.url) return assets.url
  throw new Error('Invalid response format from avatar upload')
}

export const uploadAvatar = async (file, userId) => {
  if (!file) throw new Error('No file selected')
  if (!userId) throw new Error('User ID is required')
  if (file.size / 1024 / 1024 > 2) throw new Error("File can't be larger than 2MB")
  if (!file.type.startsWith('image/')) throw new Error('Please select an image file')

  const formData = new FormData()
  formData.append('file', file)

  const response = await fetch(`${BASE_URL}guest/supabase-assets-v2/upload-avatar`, {
    method: 'POST',
    headers: authHeaders(),
    body: formData,
  })

  if (!response.ok) {
    const errorData = await parseJsonSafe(response)
    throw new Error(getErrorMessage(errorData, 'Failed to upload avatar'))
  }

  const result = await parseJsonSafe(response)
  return extractAvatarUrl(result?.data || result)
}

